<template>
    <div class="zxns_container">
        <!-- 分类胶囊 -->
        <div class="zxns_tabs">
            <div
                class="zxns_tab"
                :class="{ active: tabTypeId === item.typeId }"
                v-for="item in zxnsInfo"
                :key="item.typeId"
                @click="changeType(item.typeId)">
                {{ item.typeName }}
            </div>
        </div>

        <!-- 人才招聘 -->
        <div class="zxns_panel" v-if="tabTypeId === 1">
            <div class="zxns_head reveal-init" v-reveal>
                <span class="zxns_head_dot"></span>
                <h2 class="zxns_head_title">热招岗位</h2>
                <span class="zxns_head_en">Open positions</span>
            </div>

            <!-- 搜索条 -->
            <div class="zxns_search reveal-init" v-reveal="60">
                <div class="zxns_search_body">
                    <el-input placeholder="请输入岗位" v-model="searchInfo.positionname" class="zxns_search_input">
                        <el-select v-model="searchInfo.positionplace" slot="prepend" placeholder="请选择地点" style="width: 150px">
                            <el-option :label="item" :value="item" v-for="item in place" :key="item"></el-option>
                        </el-select>
                        <el-button slot="append" icon="el-icon-search" @click="searchPosition"></el-button>
                    </el-input>
                </div>
            </div>

            <!-- 海报拼贴职位卡 -->
            <div class="zxns_jobs" v-if="tableData.length > 0">
                <div
                    class="zxns_job reveal-init"
                    :class="idx % 2 === 0 ? 'tone-1' : 'tone-2'"
                    v-reveal="idx * 80"
                    v-for="(item, idx) in tableData"
                    :key="item.positionid != null ? item.positionid : idx"
                    @click="toggleDetail(idx)">
                    <div class="zxns_job_deco_a"></div>
                    <div class="zxns_job_deco_b"></div>
                    <div class="zxns_job_head">
                        <span class="zxns_job_no">{{ padNo(idx) }} / 招聘中</span>
                        <span class="zxns_job_toggle">{{ expandedIdx === idx ? '−' : '+' }}</span>
                    </div>
                    <div class="zxns_job_title">{{ item.positionname }}</div>
                    <div class="zxns_job_meta">
                        <span class="zxns_chip">{{ item.positionplace }}</span>
                        <span class="zxns_chip">{{ item.positionnumber }} 人</span>
                        <span class="zxns_chip">{{ fmtDate(item.createtime) }}</span>
                    </div>

                    <!-- 展开详情：海报内嵌白卡 -->
                    <div class="zxns_job_detail" v-if="expandedIdx === idx" @click.stop>
                        <div class="zxns_detail_row">
                            <span class="zxns_detail_label">职位名称</span>
                            <span class="zxns_detail_value">{{ item.positionname }}</span>
                        </div>
                        <div class="zxns_detail_row">
                            <span class="zxns_detail_label">招聘人数</span>
                            <span class="zxns_detail_value">{{ item.positionnumber }}</span>
                        </div>
                        <div class="zxns_detail_row">
                            <span class="zxns_detail_label">工作地点</span>
                            <span class="zxns_detail_value">{{ item.positionplace }}</span>
                        </div>
                        <div class="zxns_detail_row">
                            <span class="zxns_detail_label">发布时间</span>
                            <span class="zxns_detail_value">{{ item.createtime }}</span>
                        </div>
                        <div class="zxns_detail_row">
                            <span class="zxns_detail_label">更新日期</span>
                            <span class="zxns_detail_value">{{ item.edittime }}</span>
                        </div>
                        <div class="zxns_detail_row zxns_detail_skill">
                            <span class="zxns_detail_label">任职技能</span>
                            <div class="zxns_detail_rich" v-html="item.positionskill"></div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="zxns_empty reveal-init" v-reveal v-else>暂无在招岗位</div>
        </div>

        <!-- 人才理念 -->
        <div class="zxns_panel" v-if="tabTypeId === 2">
            <div class="zxns_head reveal-init" v-reveal>
                <span class="zxns_head_dot"></span>
                <h2 class="zxns_head_title">人才理念</h2>
                <span class="zxns_head_en">Philosophy</span>
            </div>

            <div class="zxns_nl reveal-init" v-reveal="80">
                <div class="zxns_nl_deco_a"></div>
                <div class="zxns_nl_deco_b"></div>
                <div class="zxns_nl_deco_c"></div>
                <div class="zxns_nl_label">让每一份才华 · 生长在山水之间</div>
                <div class="zxns_nl_body" v-if="rclnInfo.text" v-html="rclnInfo.text"></div>
                <div class="zxns_nl_body zxns_nl_empty" v-else>理念内容整理中，敬请期待</div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  data () {
    return {
      zxnsInfo: [
        { typeName: '人才招聘', typeId: 1 },
        { typeName: '人才理念', typeId: 2 }
      ],
      tabTypeId: 1,
      rclnInfo: {},
      tableData: [],
      place: [],
      searchInfo: {
        positionname: '',
        positionplace: ''
      },
      expandedIdx: -1
    }
  },
  directives: {
    // 轻量进场指令：默认可见 + 渐显（渐进增强，永不藏死内容）
    reveal: {
      inserted (el, binding) {
        const delay = binding.value || 0
        el.style.setProperty('--reveal-delay', delay + 'ms')
        const vh = window.innerHeight || document.documentElement.clientHeight
        const rect = el.getBoundingClientRect()
        if (rect.top < vh && rect.bottom > 0) {
          requestAnimationFrame(() => el.classList.add('reveal-in'))
        } else {
          const io = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                el.classList.add('reveal-in')
                io.unobserve(el)
              }
            })
          }, { threshold: 0.1, rootMargin: '0px 0px -8% 0px' })
          io.observe(el)
          el.__revealIO__ = io
        }
      },
      unbind (el) {
        if (el.__revealIO__) el.__revealIO__.disconnect()
      }
    }
  },
  methods: {
    padNo (idx) {
      return String(idx + 1).padStart(2, '0')
    },
    fmtDate (v) {
      return v ? String(v).slice(0, 10) : ''
    },
    toggleDetail (idx) {
      this.expandedIdx = this.expandedIdx === idx ? -1 : idx
    },
    searchPosition () {
      if (this.searchInfo.positionname) {
        this.searchInfo.positionname = this.searchInfo.positionname.replaceAll(/\s/g, '')
      }
      this.expandedIdx = -1
      this.getPositionByLimit()
    },
    getPositionByLimit () {
      this.$http.post('/admin/getPositionByLimit', this.searchInfo).then(res => {
        this.tableData = res.data.data
      })
    },
    getPosition () {
      this.$http.get('/admin/getPosition').then(res => {
        this.tableData = res.data.data
        this.tableData.forEach(res => {
          if (!this.place.includes(res.positionplace)) {
            this.place.push(res.positionplace)
          }
        })
      })
    },
    getSimpleText () {
      this.$http.post('/admin/getSimpleTextByType/1').then(res => {
        if (res.data.data.length > 0) {
          this.rclnInfo = res.data.data[0]
        }
      })
    },
    changeType (typeId) {
      this.tabTypeId = typeId
      window.scrollTo(0, 0)
    }
  },
  created () {
    this.getSimpleText()
    this.getPosition()
  }
}
</script>

<style lang="less" scoped>
.zxns_container {
    --ss-green-800: #163a2b;
    --ss-green: #2e6b4f;
    --ss-green-200: #e3ece5;
    --ss-sand: #f7f5f0;
    --ss-gold: #c9a86a;
    --ss-gold-soft: #e8d9b8;

    width: 100%;
    background: #fff;
    border-radius: 8px;
    padding: 0 0 24px;
    overflow: hidden;
}

/* 顶部分类胶囊（全站一致） */
.zxns_tabs {
    display: flex;
    gap: 10px;
    padding: 18px 24px;
    border-bottom: 1px solid #ece8df;
}
.zxns_tab {
    padding: 8px 22px;
    border-radius: 999px;
    font-size: 15px;
    color: #5b6b62;
    cursor: pointer;
    border: 1px solid transparent;
    transition: all .3s cubic-bezier(.22, .61, .36, 1);
    white-space: nowrap;
}
.zxns_tab:hover {
    color: var(--ss-green);
    background: #eef3f0;
}
.zxns_tab.active {
    background: var(--ss-green);
    color: #fff;
    box-shadow: 0 4px 12px rgba(22, 58, 43, .18);
}

/* 区块标题 */
.zxns_head {
    display: flex;
    align-items: baseline;
    gap: 12px;
    padding: 30px 28px 6px;
}
.zxns_head_dot {
    width: 12px;
    height: 12px;
    border-radius: 50%;
    background: var(--ss-gold);
    align-self: center;
    flex: none;
}
.zxns_head_title {
    margin: 0;
    font-size: 26px;
    font-weight: 500;
    color: var(--ss-green-800);
    letter-spacing: 2px;
}
.zxns_head_en {
    font-size: 13px;
    color: var(--ss-gold);
    letter-spacing: 1px;
}

/* 搜索条 */
.zxns_search {
    padding: 16px 28px 4px;
}
.zxns_search_body {
    max-width: 760px;
}
.zxns_search ::v-deep .el-input-group__prepend {
    background: #fff;
    border-color: #d9e2db;
    border-radius: 999px 0 0 999px;
    box-shadow: none;
}
.zxns_search ::v-deep .el-input-group__append {
    background: var(--ss-green);
    border-color: var(--ss-green);
    border-radius: 0 999px 999px 0;
    color: #fff;
    box-shadow: none;
}
.zxns_search ::v-deep .el-input-group__append .el-button {
    color: #fff;
    border: none;
    background: transparent;
}
.zxns_search ::v-deep .el-input__inner {
    border-color: #d9e2db;
}
.zxns_search ::v-deep .el-select .el-input__inner {
    border-color: transparent;
}
.zxns_search ::v-deep .el-input-group__prepend .el-input__inner,
.zxns_search ::v-deep .el-input-group__append .el-input__inner {
    background: transparent;
}

/* 海报拼贴职位卡 */
.zxns_jobs {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 20px;
    padding: 22px 28px 6px;
}
.zxns_job {
    position: relative;
    border-radius: 12px;
    padding: 22px 22px 20px;
    cursor: pointer;
    overflow: hidden;
    transition: transform .4s cubic-bezier(.22, .61, .36, 1), box-shadow .4s ease;
}
.zxns_job:hover {
    transform: translateY(-5px);
    box-shadow: 0 18px 36px rgba(22, 58, 43, .22);
}
.zxns_job.tone-1 {
    background: var(--ss-green-800);
}
.zxns_job.tone-2 {
    background: var(--ss-green);
}
.zxns_job_deco_a {
    position: absolute;
    right: -18px;
    top: -18px;
    width: 72px;
    height: 72px;
    border-radius: 50%;
    background: var(--ss-gold);
    opacity: .92;
    pointer-events: none;
    transition: transform .5s cubic-bezier(.22, .61, .36, 1);
}
.zxns_job:hover .zxns_job_deco_a {
    transform: scale(1.12);
}
.zxns_job_deco_b {
    position: absolute;
    left: 18px;
    bottom: 14px;
    width: 26px;
    height: 26px;
    border-radius: 50%;
    border: 2px solid rgba(247, 245, 240, .55);
    pointer-events: none;
}
.zxns_job_head {
    position: relative;
    z-index: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
}
.zxns_job_no {
    font-size: 13px;
    color: var(--ss-gold-soft);
    letter-spacing: 1px;
}
.zxns_job_toggle {
    width: 26px;
    height: 26px;
    border-radius: 50%;
    border: 1px solid rgba(247, 245, 240, .5);
    color: var(--ss-sand);
    font-size: 16px;
    line-height: 24px;
    text-align: center;
    flex: none;
}
.zxns_job_title {
    position: relative;
    z-index: 1;
    margin: 12px 0 0;
    font-size: 22px;
    font-weight: 500;
    color: var(--ss-sand);
    letter-spacing: 1px;
}
.zxns_job_meta {
    position: relative;
    z-index: 1;
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    margin-top: 14px;
}
.zxns_chip {
    font-size: 12px;
    color: var(--ss-sand);
    background: rgba(247, 245, 240, .16);
    border: 1px solid rgba(247, 245, 240, .28);
    border-radius: 999px;
    padding: 3px 12px;
}

/* 展开详情：海报内嵌白卡 */
.zxns_job_detail {
    position: relative;
    z-index: 1;
    margin-top: 16px;
    background: var(--ss-sand);
    border-radius: 10px;
    padding: 16px 18px;
}
.zxns_detail_row {
    display: flex;
    gap: 14px;
    padding: 7px 0;
    border-bottom: 1px solid rgba(22, 58, 43, .10);
    font-size: 14px;
}
.zxns_detail_row:last-child {
    border-bottom: none;
}
.zxns_detail_label {
    flex: none;
    width: 68px;
    color: var(--ss-green);
}
.zxns_detail_value {
    color: var(--ss-green-800);
    word-break: break-all;
}
.zxns_detail_skill {
    display: block;
}
.zxns_detail_skill .zxns_detail_label {
    display: block;
    margin-bottom: 6px;
}
.zxns_detail_rich {
    color: var(--ss-green-800);
    line-height: 1.9;
    font-size: 14px;
    word-break: break-word;
}
.zxns_detail_rich ::v-deep img {
    max-width: 100%;
    height: auto;
}
.zxns_detail_rich ::v-deep p {
    margin: 4px 0;
}

/* 空态 */
.zxns_empty {
    margin: 30px 28px;
    padding: 60px 0;
    text-align: center;
    color: #9aa79f;
    font-size: 15px;
    background: var(--ss-sand);
    border-radius: 12px;
}

/* 人才理念海报拼贴 */
.zxns_nl {
    position: relative;
    margin: 22px 28px 8px;
    background: var(--ss-sand);
    border-radius: 16px;
    padding: 48px 44px 44px;
    overflow: hidden;
}
.zxns_nl_deco_a {
    position: absolute;
    right: -56px;
    top: -56px;
    width: 160px;
    height: 160px;
    border-radius: 50%;
    background: var(--ss-gold);
    opacity: .9;
    pointer-events: none;
}
.zxns_nl_deco_b {
    position: absolute;
    left: 26px;
    bottom: 22px;
    width: 54px;
    height: 54px;
    border-radius: 50%;
    border: 2px solid var(--ss-green);
    pointer-events: none;
}
.zxns_nl_deco_c {
    position: absolute;
    left: 72px;
    bottom: 66px;
    width: 18px;
    height: 18px;
    border-radius: 50%;
    background: var(--ss-green-800);
    pointer-events: none;
}
.zxns_nl_label {
    position: relative;
    z-index: 1;
    display: inline-block;
    font-size: 13px;
    color: var(--ss-sand);
    background: var(--ss-green-800);
    border-radius: 999px;
    padding: 6px 18px;
    letter-spacing: 2px;
}
.zxns_nl_body {
    position: relative;
    z-index: 1;
    margin-top: 22px;
    max-width: 820px;
    color: var(--ss-green-800);
    font-size: 15px;
    line-height: 2;
}
.zxns_nl_body ::v-deep p {
    margin: 8px 0;
}
.zxns_nl_body ::v-deep img {
    max-width: 100%;
    height: auto;
    border-radius: 8px;
}
.zxns_nl_empty {
    color: #9aa79f;
}

/* 进场动画：默认可见 + 渐显 */
.reveal-init { }
.reveal-init.reveal-in {
    animation: zxnsReveal .7s cubic-bezier(.22, .61, .36, 1) both;
    animation-delay: var(--reveal-delay, 0ms);
}
@keyframes zxnsReveal {
    from { opacity: 0; transform: translateY(26px); }
    to   { opacity: 1; transform: none; }
}

/* 响应式 */
@media screen and (max-width: 1024px) {
    .zxns_jobs {
        grid-template-columns: 1fr;
        padding: 18px 18px 4px;
    }
    .zxns_tabs {
        padding: 14px 16px;
    }
    .zxns_head {
        padding: 22px 18px 4px;
    }
    .zxns_search {
        padding: 12px 18px 2px;
    }
    .zxns_nl {
        margin: 18px;
        padding: 36px 24px 32px;
    }
}
@media screen and (max-width: 560px) {
    .zxns_tab {
        padding: 7px 15px;
        font-size: 14px;
    }
    .zxns_head_title {
        font-size: 21px;
    }
    .zxns_head_en {
        display: none;
    }
    .zxns_search ::v-deep .el-input-group__prepend {
        width: 110px;
    }
    .zxns_search ::v-deep .el-select {
        width: 110px !important;
    }
    .zxns_job {
        padding: 18px 16px 16px;
    }
    .zxns_job_title {
        font-size: 19px;
    }
    .zxns_nl {
        margin: 14px;
        padding: 30px 18px 26px;
    }
    .zxns_nl_deco_a {
        width: 110px;
        height: 110px;
        right: -38px;
        top: -38px;
    }
}
</style>
